import { repoTypeOption, timeSort, sortBy } from './dynamicVar';
import { VITE_HOST, VITE_AI_HOST, VITE_NEWS_HOST } from '@/utils/tools';
/* 全局枚举配置 */
export enum VISIBILITY {
  PUBLIC = 'public',
  PRIVATE = 'private',
  INTERNAL = 'internal'
}

export enum SORT {
  DESC = 'desc',
  ASC = 'asc'
}

export enum COMMENT {
  /** issue 评论 */
  ISSUE = 1,
  /** pr 评论 */
  MR = 2,
  COMMIT = 3,
  DISCUSS = 4,
  /** issue 描述 */
  ISSUE_DESC = 11,
  /** pr 描述 */
  PR_DESC = 12
}
export enum FORK_REPO_SETTING_VALUE {
  DEFAULT_BRANCH = 'DEFAULT_BRANCH',
  ALL_BRANCH = 'ALL_BRANCH'
}
export const localStorageKeys = {
  merge_showformat_setting: 'merge_showformat_setting',

  // fork 默认分支或者全部分支
  fork_repo_setting: 'fork_repo_setting'
};

// 角色权限属性映射
// 具体产品文档见：https://c.csdn.net/pages/viewpage.action?pageId=145970961
export const AuthMap = {
  group: {
    delete: 'group:delete',
    setting: 'group:setting',
    update: 'group:update'
  },
  repo: {
    delete: 'repo:delete',
    fork: 'repo:fork',
    update: 'repo:update',
    create: 'repo:create',
    setting: 'repo:setting',
    archive: 'repo:archive',
    transfer: 'repo:transfer'
  },
  // wiki权限独立
  wiki: {
    push: 'wiki:push',
    download: 'wiki:download'
  },
  code: {
    push: 'code:push',
    download: 'code:download'
  },
  // 此处暂不区分组织或项目得成员，因为后端不做区分
  member: {
    create: 'member:create',
    update: 'member:update',
    delete: 'member:delete'
  },
  issue: {
    create: 'issue:create',
    update: 'issue:update',
    delete: 'issue:delete',
    reopen: 'issue:reopen',
    pin: 'issue:pin', // 置顶
    lock: 'issue:lock', // 锁定
    close: 'issue:reopen',
    transfer: 'issue:transfer'
  },
  // 组织标签
  label: {
    create: 'label:create',
    update: 'label:update',
    delete: 'label:delete'
  },
  // 里程碑
  milestone: {
    create: 'milestone:create',
    update: 'milestone:update',
    delete: 'milestone:delete'
  },
  branch: {
    create: 'branch:create',
    delete: 'branch:delete'
  },
  tag: {
    create: 'tag:create',
    delete: 'tag:delete'
  },
  // release权限同步tag
  release: {
    create: 'tag:create',
    delete: 'tag:delete'
    // create: 'release:create',
    // delete: 'release:delete',
    // update: 'release:update'
  },
  pr: {
    create: 'pr:create',
    review: 'pr:review',
    update: 'pr:update',
    approve: 'pr:approve',
    merge: 'pr:merge',
    reopen: 'pr:reopen',
    close: 'pr:close',
    test: 'pr:test'
  },
  note: {
    create: 'note:create',
    resolve: 'note:resolve'
  },
  discussion: {
    create: 'discussion:create',
    lock: 'discussion:lock',
    update: 'discussion:update',
    read: 'discussion:read',
    pin: 'discussion:pin',
    close: 'discussion:close',
    delete: 'discussion:delete'
  },
  // 看板
  board: {
    create: 'kanban:create',
    delete: 'kanban:delete',
    update: 'kanban:update',
    close: 'kanban:close',
    read: 'kanban:read'
  },
  // 流水线
  pipeline: {
    create: 'pipeline:create',
    delete: 'pipeline:delete',
    update: 'pipeline:update',
    run: 'pipeline:run',
    rerun: 'pipeline:rerun'
  },
  // 空间
  space: {
    create: 'space:create',
    delete: 'space:delete',
    update: 'space:update',
    setting: 'space:setting',
    pause: 'space:pause',
    transfer: 'space:transfer',
    activate: 'space:activate',
    logging: 'space:logging'
  },
  // 合集
  collection: {
    create: 'collection:create',
    delete: 'collection:delete',
    update: 'collection:update'
  }
};

// 权限依赖表
export const RelyAuthMap = {
  [AuthMap.tag.create]: [AuthMap.code.push, AuthMap.code.download],
  [AuthMap.tag.delete]: [AuthMap.code.push, AuthMap.code.download],
  [AuthMap.branch.create]: [AuthMap.code.push, AuthMap.code.download],
  [AuthMap.branch.delete]: [AuthMap.code.push, AuthMap.code.download],
  [AuthMap.code.push]: [AuthMap.code.download],
  [AuthMap.wiki.push]: [AuthMap.wiki.download],
  // [AuthMap.repo.fork]: [AuthMap.code.download],
  [AuthMap.pr.merge]: [AuthMap.code.push, AuthMap.code.download],
  [AuthMap.board.update]: [
    AuthMap.issue.update,
    AuthMap.pr.update,
    AuthMap.pr.close,
    AuthMap.pr.reopen,
    AuthMap.issue.close,
    AuthMap.issue.reopen
  ],
  [AuthMap.milestone.update]: [
    AuthMap.issue.update,
    AuthMap.pr.update,
    AuthMap.pr.close,
    AuthMap.pr.reopen,
    AuthMap.issue.close,
    AuthMap.issue.reopen
  ],
  [AuthMap.pr.update]: [AuthMap.pr.close, AuthMap.pr.reopen],
  [AuthMap.issue.update]: [AuthMap.issue.reopen],
  [AuthMap.label.create]: [AuthMap.label.update],
  [AuthMap.discussion.close]: [AuthMap.note.create],
  [AuthMap.issue.reopen]: [AuthMap.note.create],
  [AuthMap.issue.transfer]: [AuthMap.issue.create],
  [AuthMap.pipeline.run]: [AuthMap.pipeline.rerun],
  [AuthMap.pipeline.rerun]: [AuthMap.pipeline.run],
  [AuthMap.pipeline.create]: [AuthMap.code.push],
  [AuthMap.pipeline.update]: [AuthMap.code.push]
};

// 帮助文档链接
export const HELP_DOCS_URL = (() => {
  if (location.host.includes('atomgit.com')) {
    return 'https://docs.atomgit.com';
  }
  return 'https://docs.gitcode.com';
})();

// 组织前缀
export const ORG_PREFIX = 'organization';

// 社区前缀
export const COMMUNITY_PREFIX = 'organization-gitcode';

export const AnnotationStatus = {
  success: 'success',
  failed: 'failure',
  warning: 'warning'
};

export const ISSUE_PR_API_PREFIX = 'issuepr';

export const NOT_ALLOW_INSERT_CODE_SUGGESTION = '--not-allow-insert-code-suggestion--';

// 主站域名
export const SITE_HOST = VITE_HOST();

// ai社区域名
export const AI_HOST = VITE_AI_HOST();

// news资讯中心域名
export const NEWS_HOST = VITE_NEWS_HOST();

// 生产环境
export const IS_PROD = import.meta.env.VITE_ENV === 'production';

// 预发环境
export const IS_PRE = import.meta.env.VITE_ENV === 'pre';

// 开发环境
export const IS_DEV = import.meta.env.VITE_ENV === 'development';

// 网站状态
export const SITE_STATUS = {
  DISABLE: false, // 是否维护中（true代表全站维护）
  COMMUNITY: false // 是否开启社区
};

// mdEditor 上传文件类型
export const ACCEPT_FILE_TYPES = [
  '.gif',
  '.jpeg',
  '.jpg',
  '.mov',
  '.mp4',
  '.png',
  '.svg',
  '.webm',
  '.cpu-profile',
  '.csv',
  '.dmp',
  '.docx',
  '.fodg',
  '.fodp',
  '.fods',
  '.fodt',
  '.gz',
  '.json',
  '.jsonc',
  '.log',
  '.md',
  '.odf',
  '.odg',
  '.odp',
  '.ods',
  '.odt',
  '.patch',
  '.pdf',
  '.pptx',
  '.tgz',
  '.txt',
  '.xls',
  '.xlsx',
  '.zip',
  '.cj'
];

export const FILE_TYPES: any = {
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  mov: 'video/quicktime',
  mp4: 'video/mp4',
  png: 'image/png',
  svg: 'image/svg+xml',
  webm: 'video/webm',
  cpuprofile: 'application/octet-stream',
  csv: 'text/csv',
  dmp: 'application/octet-stream',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  fodg: 'application/vnd.oasis.opendocument.graphics',
  fodp: 'application/vnd.oasis.opendocument.presentation',
  fods: 'application/vnd.oasis.opendocument.spreadsheet',
  fodt: 'application/vnd.oasis.opendocument.text',
  gz: 'application/gzip',
  json: 'application/json',
  jsonc: 'application/jsonc',
  log: 'text/plain',
  md: 'text/markdown',
  odf: 'application/vnd.oasis.opendocument.formula',
  odg: 'application/vnd.oasis.opendocument.graphics',
  odp: 'application/vnd.oasis.opendocument.presentation',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  odt: 'application/vnd.oasis.opendocument.text',
  patch: 'application/octet-stream',
  pdf: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  tgz: 'application/gzip',
  txt: 'text/plain',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip',
  cj: 'application/octet-stream'
};

// 已经访问用户成长
export const ALREADY_VISIT_USER_GROWTH_CENTER = '1';

// commit列表安全审核规则及显示条数
export const COMMIT_LIST_SAFE_AUDIT_RULE = {
  RULE: false, // false: 全部显示 true: 只显示最近条数
  SHOW_NUM: 50 // 显示条数
};

export enum CLA_SOURCE {
  GITCODE = 'gitcode',
  DEVPRESS = 'devpress'
}

export enum CLA_STATUS {
  ENABLE = 0
}
// 首页左侧路由导航栏
export const MENU_ITEM_ROUTE_NAME = [
  'home',
  'gStar',
  'trusted',
  'aiCopilot',
  'kanban',
  'contributed',
  'issues',
  'merge',
  'discussionCreated',
  'explore',
  'userFollowing',
  'userStars',
  'ai'
];
// 头像点击变量名
export const AVATAR_VISITED_DATE = 'avatar-visitedDate';
export const AVATAR_VISITED_USERNAME = 'avatar-visited-username';

// 头像点击变量名
export const GROWTH_VISITED_DATE = 'growth-visitedDate';
export const GROWTH_VISITED_USERNAME = 'growth-visited-username';

// 华为云广告链接
export const HUAWEI_AD_LINK =
  'https://auth.huaweicloud.com/authui/saml/login?xAccountType=hid_ochgo94c_ruldd9_IDP&isFirstLogin=false&service=https%3A%2F%2Fdeveloper.huaweicloud.com%2Fspace%2Fdevportal%2Fdesktop%3Futm_source%3Dgitcodedspace%26utm_adplace%3Dgitcodexyhbd';

// 仓颉广告链接
export const CANGJIE_AD_LINK =
  'https://developer.huaweicloud.com/space/devportal/desktop?utm_source=gitcodedspace&utm_adplace=gitcodecangjie';

// 登录华为云
export const HUAWEI_CLOUD_LOGIN_LINK =
  'https://auth.huaweicloud.com/authui/saml/login?xAccountType=hid_ochgo94c_ruldd9_IDP&isFirstLogin=false&service=';

// 在云主机中打开
export const HUAWEI_CLOUD_SERVICE_LINK =
  'https://developer.huaweicloud.com/space/devportal/desktop?utm_source=gitcodedspace&utm_adplace=gitcodecprh';
// 点击事件模块
export enum CLICK_TIME_MODULE {
  // 首页
  HOME = 'home',
  // gStar
  GSTAR = 'gStar',
  // 成长中心
  GROWTH_CENTER = 'growthCenter'
}

// 成就状态
export enum ACHIEVEMENT_STATUS {
  UNFINISHED = 0, // 未完成
  UNLIT = 1, // 未点亮
  FINISHED = 2 // 已完成点亮
}
/** 是否访问快捷登录（用于防止重复上报）*/
export const GOTO_QUICK_LOGIN = 'gotoQuickLogin';

export const DEFAULT_COUNTRY = 'CN_0086';

export const IMAGE_CDN_PREFIX = 'https://cdn-static.gitcode.com';

export const OSS_IMAGES = {
  gstar: '/static/images/homeweb/gstar-tag-twinkle.gif',
  trusted: '/static/images/homeweb/trusted-tag.png',
  incubation: '/static/images/homeweb/gstar-incubation.gif'
};

/** 华为云开发者生态隐私政策声明 */
export const HWYDeveloperPPS = 'https://www.huaweicloud.com/declaration/sa_devprp.html';

/** 华为云开发者服务协议 */
export const HWYDeveloperSA = 'https://www.huaweicloud.com/declaration/developer_service_agreement.html';

export { repoTypeOption, timeSort, sortBy };

// 解析MetaUI正则
export const YamlSectionRegex = /^---\n([\s\S]*?)\n---$/m;

/** 注册来源（弹出登录框时设置）*/
export const UTM_SOURCE = 'utm_source';

/** 个人设置-流水线 */
export const ATOMGIT_PATH = '/setting/pipeline';

/** 用户模块前缀 */
export const PASSPORT_PREFIX = '/uc';

/** 第三方授权页窗口名 */
export const AUTH_WINDOW = 'auth_window';

/** 微前端应用名称 */
export const HOMEWEB_APP_NAME = 'micoro-app-homeweb-app';

/** 微前端应用基础路由 */
export const HOMEWEB_BASEROUTE = ['/child/homeweb-app/', '/child-app/homeweb-app/'];

/** 成长中心应用名称 */
export const UC_MICRO_NAME = 'growth-center';

/** 成长中心应用基础路由 */
export const GROWTH_CENTER_BASEROUTE = ['/', '/child/growth-center/', '/child-app/growth-center/'];

export const ROLE_FROM = {
  GROUP: 'Namespace',
  ENTERPRISE: 'Enterprise'
};

export const MEMBER_TYPE = {
  ENTERPRISE: 'EnterpriseMember',
  GROUP: 'GroupMember',
  REPO: 'ProjectMember'
};

// 埋点 event-id
/** 登录弹窗 tab 切换上报 */
export const LOGIN_MODAL_TAB_SWITCH = 'loginModal_click';

/** 注册来源 tab - 上报 */
export const REGISTER_SOURCE_TAB_REPORT = 'loginModal_register_click';

/** 三方oauth登录取消授权，上报 */
export const OAUTH_CANCEL = 'oauth_cancel';

//  ------------------sessionStorage 暂存 Key-------------------//
/** 第三方登录类型 */
export const OAUTH_LOGIN_TYPE_KEY = 'oauthType';

/** 注册账号-来源 tab */
export const REGISTER_SOURCE_TAB = 'register_source_tab';

/** 登录弹窗-触发入口 */
export const LOGIN_MODAL_TRIGGER_SOURCE = 'login_trigger_source';

export const ASIDE_MENU_MODE = {
  collapse: {
    collapse: 0,
    expand: 76
  },
  default: {
    collapse: 76,
    expand: 240
  }
};

// 热门标签
export const HOT_FLAG_MAP = {
  hot_today: 'hot_today',
  hot_star: 'hot_star',
  hot_download: 'hot_download',
  hot_recommend: 'hot_recommend',
  hot_recommend_star: 'hot_recommend_star'
};
// 工具栏背景图配置
export const TOOLBAR_CONFIG = 'toolbarConfig';

// csdn博客应用授权登录
export const CSDN_BLOG_SOURCE = 'csdn-blog-childwindow';

/** 链接中的成长中心的邀请码key */
export const POINT_INVITE_CODE = 'picode';

// 系统字段支持：title、finishedAt、artsCreatedAt、artsUpdatedAt、issueType、issueStatus、issuePriority
// 自定义字段：文本、数字、日期类型的
export const CAN_SORT_FIELD_TYPE = [
  'title',
  'finishedAt',
  'artsCreatedAt',
  'artsUpdatedAt',
  'issueType',
  'issueStatus',
  'issuePriority',
  'text',
  'number',
  'date'
];
export const CAN_SORT_FIELD_TYPE_ISSUE = [
  'title',
  'finishedAt',
  'artsCreatedAt',
  'artsUpdatedAt',
  'issueType',
  'issueStatus',
  'issuePriority'
];

/** 特别邀请码 key */
export const SI_C = 'si_c';

// 贵阳环境域名
export const GUI_YANG_GITCODE_HOST = 'gitcode.host';

// 帮助文档链接
export const HELP_DOCS_URL_GITCODE = 'https://docs.gitcode.com';
export const HELP_DOCS_URL_ATOMGIT = 'https://docs.atomgit.com';
